module.exports = __webpack_public_path__ + "img/play-off.06c00bc6.svg";